<template>
  <div class="container">
    <div class="title">企业基本信息</div>
    <Row class="item-wrap margin-bottom20">
      <Col span="10" class="item-title">*企业LOGO：</Col>
      <Col span="14">
        <div v-if="companyInfo.logo" @click="clickUpload('logoinput')">
          <img :src="companyInfo.logo" alt />
          <input
            id="fileinput"
            ref="logoinput"
            type="file"
            @change="change($event,'0','logo')"
            multiple
            hidden
          />
        </div>
        <div v-else>
          <Button class="fileinput-btn" icon="md-add" @click="clickUpload('logoinput')">
            <div>
              <input
                id="fileinput"
                ref="logoinput"
                type="file"
                @change="change($event,'0','logo')"
                multiple
                hidden
              />
              上传图片
            </div>
          </Button>
        </div>
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">*企业全称：</Col>
      <Col span="14">
        <Input v-model="companyInfo.name" placeholder="请填写企业全称" style="width: 300px" />
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">*联系人：</Col>
      <Col span="14">
        <Input v-model="companyInfo.contact_name" placeholder="请填写联系人" style="width: 300px" />
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">*联系人电话：</Col>
      <Col span="14">
        <Input v-model="companyInfo.contact_phone" placeholder="请填写联系人电话" style="width: 300px" />
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">*企业邮箱：</Col>
      <Col span="14">
        <Input v-model="companyInfo.email" placeholder="请填写企业邮箱" style="width: 300px" />
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">*企业地址：</Col>
      <Col span="14" @click.native="getSite">
        <Input v-model="companyInfo.address" placeholder="请选择企业地址" style="width: 300px" readonly />
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">*详细地址：</Col>
      <Col span="14" v-if="companyInfo.address_name">
        <Input
          v-model="companyInfo.address_name"
          style="width: 300px"
        />
      </Col>
      <Col v-if="!companyInfo.address_name" span="14"  @click.native="getSite">
        <Input
          v-model="companyInfo.address_name"
          placeholder="请填写详细地址"
          style="width: 300px"
          readonly
        />
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">*企业统一社会信用代码/组织机构代码：</Col>
      <Col span="14">
        <Input
          v-model="companyInfo.credit_code"
          placeholder="请填写企业统一社会信用代码/组织机构代码"
          style="width: 300px"
        />
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">*所有制：</Col>
      <Col span="14">
        <Select
          v-model="companyInfo.ownership"
          style="width:300px"
          @on-change="bindSuoyouzhiChange"
        >
          <Option v-for="item in suoyouzhiArray" :value="item.name" :key="item.id">{{ item.name }}</Option>
        </Select>
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">*企业规模：</Col>
      <Col span="14">
        <Select v-model="companyInfo.staff_size" style="width:300px" @on-change="bindGuimoChange">
          <Option v-for="item in guiMoArray" :value="item.name" :key="item.id">{{ item.name }}</Option>
        </Select>
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">*所属行业：</Col>
      <Col span="14">
        <Select
          v-model="companyInfo.industry_name"
          style="width:300px"
          @on-change="bindIndustriesChange"
        >
          <Option v-for="item in industries" :value="item.name" :key="item.id">{{ item.name }}</Option>
        </Select>
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">*管理机构：</Col>
      <Col span="14">
        <div class="item-value" v-if="companyInfo.union_id">{{companyInfo.administration}}</div>
        <Select
          v-else
          v-model="companyInfo.union_id"
          style="width:300px"
          @on-change="bindUnionChange"
        >
          <Option v-for="item in unions" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">*是否组建工会：</Col>
      <Col span="14">
        <Select v-model="companyInfo.has_union" style="width:300px" @on-change="bindZujianChange">
          <Option v-for="item in zuJianArray" :value="item.name" :key="item.id">{{ item.name }}</Option>
        </Select>
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20">
      <Col span="10" class="item-title">*营业执照上传：</Col>
      <Col span="14">
        <div v-if="companyInfo.attachment">
          <img :src="companyInfo.attachment" @click="clickUpload('zhizhaoFIle')" alt />
          <input
            ref="zhizhaoFIle"
            type="file"
            @change="change($event,'0','attachment')"
            multiple
            hidden
          />
        </div>
        <div v-else>
          <Button class="fileinput-btn" icon="md-add" @click="clickUpload('zhizhaoFIle')">
            <div>
              <input
                ref="zhizhaoFIle"
                type="file"
                @change="change($event,'0','attachment')"
                multiple
                hidden
              />
              上传图片
            </div>
          </Button>
        </div>
        <div class="tips">要求上传相关证件，上传图片不能过分压缩，以免影响后续审核</div>
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20">
      <Col span="10" class="item-title"><div>*简介：</div></Col>
      <Col span="10">
        <editor ref="editor" v-model="companyInfo.description"></editor>
      </Col>
    </Row>
    <div class="btn-wrap">
      <Button type="primary" @click="doSubmit">{{editmode?'保存':'提交'}}</Button>
    </div>
    <Drawer title="地图" width="500" :closable="true" :mask-closable="false" v-model="oMap">
      <Map @setSite="setSite"></Map>
    </Drawer>
  </div>
</template>

<script>
import Map from "@/components/map/map";
import editor from "@/components/editor/editor";
import { filesize, shorten } from "@/libs/util";
import * as qiniu from "qiniu-js";
var maxsize = 1024 * 1024 * 8; // 最大8MB
export default {
  data() {
    return {
      zuJianArray: [
        { id: 0, name: "是" },
        { id: 1, name: "否" }
      ],
      guiMoArray: [],
      suoyouzhiArray: [],
      unions: [],
      industries: [],
      companyInfo: {},

      params: {
        parent: 0, // 父文件 (当前目录)
        sort: "uploaded", // 排序字段
        asc: false // 是否正序
      },
      editmode: this.$route.query.editmode || false,
      oMap: false
    };
  },
  components: { editor, Map },
  mounted() {
    this.init();
    if (this.$route.query.editmode) {
      this.initCompanyInfo();
    }
    if (this.$route.query.name) {
      this.$set(this.companyInfo, "name", this.$route.query.name.trim());
    }
  },
  methods: {
    getText(html) {
      this.companyInfo.description = html;
    },
    //设置富文本内容
    setHtml(description) {
      this.$emit("setHtml", description);
    },
    closeMap() {
      this.oMap = false;
    },
    getSite() {
      this.oMap = true;
    },
    setSite(e) {
      this.oMap = false;
      this.companyInfo.latitude = e.latlng.lat;
      this.companyInfo.longitude = e.latlng.lng;
      this.companyInfo.address = e.poiaddress;
      this.companyInfo.address_name = e.poiname;
    },
    init() {
      this.$axios.request({ url: "api/common/unions" }).then(res => {
        this.unions = res.data;
      });
      this.$axios.request({ url: "api/common/industries" }).then(res => {
        let data = res.data;
        data.map((item, index) => {
          this.industries.push({ id: index, name: item });
        });
      });
      this.$axios.request({ url: "api/common/staffSizeList" }).then(res => {
        let data = res.data;
        data.map((item, index) => {
          this.guiMoArray.push({ id: index, name: item });
        });
      });
      this.$axios.request({ url: "api/common/companyType" }).then(res => {
        let data = res.data;
        data.map((item, index) => {
          this.suoyouzhiArray.push({ id: index, name: item });
        });
      });
    },
    initCompanyInfo() {
      return this.$axios.request({ url: "api/qiye/mycompany" }).then(res => {
        this.companyInfo = res.data;
      });
    },
    bindIndustriesChange(value) {},
    bindZujianChange(value) {
      this.$set(this.companyInfo, "has_union", value);
    },
    bindGuimoChange(value) {
      this.$set(this.companyInfo, "staff_size", value);
    },
    bindIndustriesChange(value) {
      this.$set(this.companyInfo, "industry_name", value);
    },
    bindUnionChange(value) {
      this.unions.map(item => {
        if (item.name === item) {
          this.$set(this.companyInfo, "union_id", item.id);
        }
      });
      this.$set(this.companyInfo, "administration", value);
    },
    bindSuoyouzhiChange(value) {
      this.$set(this.companyInfo, "ownership", value);
    },
    clickUpload(type) {
      this.$refs[type].click();
      // this.$refs[type].change();
    },
    change(e, folder, type) {
      console.log(type);
      // 开始选择文件(上传)
      let folders = folder;
      this.queue = [];
      if (this.token) return this.upload(e.target, folder);
      else {
        this.$axios
          .request({
            url: "api/common/qiniu/front-token",
            method: "get"
          })
          .then(res => {
            let token = res.success ? res.data.uptoken : "";
            // token = this.token;
            let domain = res.success ? res.data.domain : "";
            this.upload(e.target, folders, token, domain, type);
          });
      }
    },
    // type : logo or attachment
    upload(target, folder, token, domain, type) {
      let folders = folder;
      var that = this;
      // that.uploadComplete = 2; // 上传未完成
      
      for (let file of target.files) {
        that.showQueue = true;
          if (!file.type.startsWith("image/")){
            that.$Notice.warning({
              desc:'请上传图片格式'
            });
            return;
          }
        if (file.size > maxsize) {
          that.$Notice.warning({
            desc:
              "文件`" +
              file.name +
              "`大小超过限制, 请上传小于" +
              filesize(maxsize) +
              "的文件"
          });
          that.showQueue = false;
          continue;
        }
        let task = {
          complete: false,
          total: {
            percent: 0,
            loaded: 0,
            size: 0
          },
          size: file.size,
          name: file.name,
          type: file.type,
          url: ""
        };
        if (file.type.startsWith("image/") && file.type.indexOf("webp") > 0) {
          // 如果为图片文件, 读取DataURL显示图片
          this.$Message.error({
            content: "文件列表中含有 webp 格式文件，暂不支持上传该格式文件"
          });
          return false;
        } else {
          let reader = new FileReader();
          folders = "0";
          reader.readAsDataURL(file);
          reader.onload = e => (task.url = e.target.result);
        }
        let key = shorten() + file.name.substr(file.name.lastIndexOf("."));
        task.subscription = qiniu.upload(file, key, token).subscribe({
          next(res) {
            task.total = res.total;
          },
          error(err) {
            return err;
          },
          complete(res) {
            let oUrl = domain + res.key;
            that.$set(that.companyInfo, type, oUrl);
            that.showQueue = false;
          }
        });
      }
    },
    doSubmit() {
      this.$axios
        .request({
          url: "api/qiye/companies",
          method: "post",
          data: this.companyInfo
        })
        .then(res => {
          if (res.success) {
            this.$Notice.success({
              title: res.data.msg
            });
            this.$router.back();
          }
        });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 40px 0;
  .editor-wrapper {
    width: 350px;
  }
}
.title {
  padding-left: 420px;
  color: #363e4f;
  font-size: 16px;
  margin-bottom: 20px;
}
.item-wrap {
  .item-title {
    text-align: right;
    padding-right: 10px;
  }
  .tips {
    font-size: 12px;
    margin-top: 10px;
  }
  img {
    width: 96px;
    height: 96px;
    cursor: pointer;
  }
  /deep/ .fileinput-btn {
    padding: 5px 22px;
    .ivu-icon {
      font-size: 30px;
    }
  }
}
.margin-bottom20 {
  margin-bottom: 20px;
}
.btn-wrap {
  padding-left: 726px;
}
</style>